module.exports = __webpack_public_path__ + "static/02-3210f416a6afbfd38bd53d1041e8f703.jpg";